import { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Autocomplete,
  Card,
  CardMedia,
} from "@mui/material";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseFooterLinks } from "./UseFooterLinks";
import { useNavigate, useLocation } from "react-router-dom";
import { FileUploader } from "react-drag-drop-files";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function AddMagLink() {
  const location = useLocation();
  const navigate = useNavigate();
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { isSmall } = useBreakpoints();
  const { SetFooterLinks, validateLink } = UseFooterLinks();
  const [state, setState] = useState({
    url: undefined,
    title: undefined,
  });
  const [imgState, setImgState] = useState({
    imageFile: undefined,
    imageUrl: undefined,
  });

  const [errorState, setErrorState] = useState({
    title: false,
    url: false,
  });

  const handleChangeImage = (file) => {
    setImgState({
      imageFile: file[0],
      imageUrl: URL.createObjectURL(file[0]),
    });
  };

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/magFooterManage",
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/magmanagment" },
          {
            name: "مدیریت فوتر",
            url: "/magFooterManage",
          },
          {
            name: "افزودن لینک",
            url: "/magFooterManage/addLink",
          },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
        <Box gridColumn={isSmall ? "span 12" : "span  3"}>
          <TextField
            fullWidth
            value={state.title ? state.title : ""}
            label="عنوان"
            error={errorState.title}
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, title: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span  8"}>
          <TextField
            fullWidth
            value={state.url ? state.url : ""}
            label="لینک"
            sx={{
              textarea: { direction: "rtl" },
            }}
            error={errorState.url}
            multiline
            maxRows={4}
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, url: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 4"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span  2"}>
          <FileUploader
            multiple={true}
            handleChange={(evt) => handleChangeImage(evt)}
            name="file"
            types={fileTypes}
            children={
              <Box sx={{ width: "100px", height: "auto" }}>
                <Card
                  sx={{
                    p: 1,
                    border: "1px",
                    borderStyle: "dashed",
                    borderColor: "secondary.main",
                    borderRadius: 4,
                    boxShadow: 0,
                    cursor: "pointer",
                    bgcolor: "#d3d3d3",
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: "100%", height: "100%" }}
                    image={
                      imgState.imageUrl
                        ? imgState.imageUrl
                        : "/static/img/no-photos.png"
                    }
                  />
                </Card>
              </Box>
            }
          />
        </Box>
        {!isSmall && <Box gridColumn="span 10"></Box>}
        <Box
          gridColumn={isSmall ? "span 12" : "span  3"}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            onClick={() => {
              if (
                validateLink(state, imgState.imageUrl, setErrorState) == 200
              ) {
                setProgress(true);
                SetFooterLinks(state, imgState.imageFile, (calback) => {
                  navigate("/magFooterManage", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                });
              }
            }}
          >
            ثبت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
